import type { GetActivitiesSectionsQuery } from '../../../lesson-builder.graphql.generated';
import { ComponentGif } from '../../component.constants';
import { preloadImages } from 'approot/shared/logic/preload-images';
import { ACTIVITIES_COMPONENT_TYPE_GIF } from 'global/constants';
import { getComponentsOfType } from './get-components-of-type';
import type { Pluck } from 'lib/gql/pluck';

export function preloadGifFiles(
  section: Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections'>
) {
  const components = getComponentsOfType<ComponentGif>({
    components: section.components,
    types: [ACTIVITIES_COMPONENT_TYPE_GIF],
  });
  const urls: string[] = [];

  components.forEach(c => {
    if (c.properties.image?.original) {
      urls.push(c.properties.image.original);
    }
  });

  preloadImages(urls);
}
